import { Textarea } from 'components/forms/Textarea';
import { InlineEditor } from 'components/inline_edit/InlineEditor';
import { TextInlineEditorProps } from 'components/inline_edit/TextInlineEditor';
import { useInlineEditor } from 'custom_hooks/useInlineEditor';

export type TextAreaInlineEditorProps = TextInlineEditorProps &
    Readonly<{
        /**
         * Optional number for minimum number of lines to be displayed when editing in the text area.
         */
        minRows?: number;
        /**
         * Optional number for minimum number of lines to be displayed when editing in the text area.
         */
        maxRows?: number;
        /**
         * Optional maximum length counter. If no length is provided, the counter will not be shown.
         */
        maximumLength?: number;
    }>;

export function TextAreaInlineEditor({
    value,
    renderValue,
    validate,
    onConfirm,
    onClose,
    isDisabled,
    editorClass,
    editorStyle,
    valueClass,
    valueStyle,
    formatInput,
    minRows,
    maxRows,
    maximumLength,
}: TextAreaInlineEditorProps) {
    const {
        valueToRender,
        inputValue,
        error,
        setInputValue,
        isEditing,
        isConfirming,
        openEditor,
        closeEditor,
        confirm,
        canConfirm,
    } = useInlineEditor<string>({
        value,
        validate,
        onConfirm,
        onClose,
    });
    return (
        <InlineEditor
            value={renderValue ? renderValue(valueToRender) : <>{valueToRender}</>}
            editor={
                <Textarea
                    className="inline-block full-width"
                    value={inputValue}
                    minRows={minRows}
                    maxRows={maxRows}
                    onChange={(e) =>
                        setInputValue(
                            formatInput ? formatInput(e.target.value) : e.target.value
                        )
                    }
                    disabled={isDisabled}
                    maxLength={maximumLength}
                    showLengthIndicator={maximumLength !== undefined}
                />
            }
            valueClass={valueClass}
            valueStyle={valueStyle}
            editorClass={editorClass}
            editorStyle={editorStyle}
            error={error}
            canClose={!isConfirming}
            canEdit={!isConfirming}
            canConfirm={canConfirm}
            isEditing={isEditing}
            isDisabled={isDisabled || isConfirming}
            isPending={isConfirming}
            onClose={closeEditor}
            onEdit={openEditor}
            onConfirm={confirm}
        />
    );
}
